import * as React from "react";
import Dialog from "components/dialog";
import { format } from "lib/globalize-util";
import Button from "components/form/button";

interface IProps {
    open: boolean;
    onClose: () => void;
}

export const CustomizationMissingCompanyWarningDialog: React.FC<IProps> = ({ open, onClose }) => {
    return (
        <Dialog
            onRequestClose={onClose}
            title={format("Missing Company")}
            open={open}
            actions={[<Button key="btn-dismiss" label={format("Dismiss")} onClick={onClose} />]}
        >
            <div>{format("Please start a new order or navigate to your working order and select a company")}</div>
        </Dialog>
    );
};
